import { ComplianceRepository } from "../../repositories/ComplianceRepository";
import { ComplianceTypeEntity } from "../../entities/ComplianceTypeEntity";

export class UpdateComplianceTypeUseCase {
  constructor(private repository: ComplianceRepository) {}

  async execute(id: number, data: Partial<ComplianceTypeEntity>): Promise<ComplianceTypeEntity> {
    if (!id) {
      throw new Error("Compliance type ID is required");
    }

    return await this.repository.updateComplianceType(id, data);
  }
}

